import React from 'react'

export default () => {
    return (
        <>
            <h3>Allemand</h3>
            <ul>
                <li>
                    <h4>Altissia</h4>
                    <a href="https://learn.altissia.org/gw/api/saml/init?idp=https://auth-ext.heig-vd.ch/realms/enrolment&service=LA_STANDALONE" target='_blank'>
                        Lien plateforme Altissia
                    </a>
                </li>
                <li>
                    <h4>Profil linguistique</h4>
                    <p>
                        Remplir le{' '}
                        <a href="https://lingo-log.heig-vd.ch/de" target="_blank" rel="noopener noreferrer">
                            formulaire de profil linguistique
                        </a>{' '}
                        dans la langue cible et non en français (dernier délai : 30 juin)
                    </p>
                    <p></p>
                </li>
            </ul>
        </>
    )
}
